"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MFFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_147)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_147`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#003787"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30L14 16V24H10V16L-6 0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9999 12.6666C13.4727 12.6666 14.6666 11.4727 14.6666 9.99998C14.6666 8.52722 13.4727 7.33331 11.9999 7.33331C10.5272 7.33331 9.33325 8.52722 9.33325 9.99998C9.33325 11.4727 10.5272 12.6666 11.9999 12.6666Z",
					fill: "#F9D90F"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.66675 10H15.3334L12.0001 16L8.66675 10Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.0001 16L6.66675 11H17.3334L12.0001 16Z",
					fill: "#CF142B"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_147`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MFFlag };
